export const constants = {
    description:
        "You can use this form to create a custom region. Once created, you'll be able to see all information corresponding to the regions selected in Step 2 when navigating Quorum.",
}

export default constants

// match current_preset_name max_length app/userdata/models.py > UserInfo > current_preset_name
export const CUSTOM_REGION_NAME_MAX_LENGTH = 100
